module.exports = __webpack_public_path__ + "img/harshita-jain-logo-white.3b857e2b.png";